import React, { createContext, useState } from "react";
import { useLocalStorage, getBalanceCreditDebit } from "../resources/Hooks";
import db from "../resources/db";
import jsonata from 'jsonata'
import { updateStockItemData } from "../pages/Stocks/StockItemDetail/StockItemDetail";

/** App Configuration Object */
let config = {
    lisenced: false,
    lisencee: null,
    productType: "demo",
    registrationDate: null,
    serial: null,
    expiryDate: null,
    expired: false,
    gst: {
        enabled: false,
        GSTRate: 0,
        inclusive: false,
    },
    whatsapp: false,
    scheduledBackup: {
        enabled: false,
        duration: (1000 * 60 * 60 * 24 * 7) // 7 days
    }
};

export const ConfigContext = createContext({
    getData: async () => { },
    getStocks: async () => [],
    getStocksValue: async () => 0,
    getInvoices: async () => [],
    getSalesAmount: async () => 0,
    getPurchase: async () => [],
    getPurchaseAmount: async () => 0,
    getLedger: async () => [],
    getLedgerValues: async () => ({
        payable: 0,
        receivable: 0,
        cashinHand: 0,
        balance: 0,
        credit: 0,
        debit: 0,
    }),
    getExpenses: async () => [],
    getExpenseAmount: async () => 0,
    getPartyList: async () => [],
    getCustomerList: async () => [],
    getCompany: async () => ({
        name: "",
        address: "",
        contact: "",
        gst: "",
        lastInvNo: 1,
        lastGstInvNo: 1,
    }),
});

const ConfigContextProvider = props => {
    const [Config, setConfig] = useLocalStorage("config", config);
    const [Stocks, setStocks] = useState([]);
    const [Ledger, setLedger] = useState([]);
    const [Invoices, setInvoices] = useState([])
    const [Purchase, setPurchase] = useState([])
    const [CustomerList, setCustomerList] = useState([]);
    const [Expenses, setExpenses] = useState([]);

    const [Company, setCompany] = useState(() => {

        db.companies.get(1).then((res) => {
            res && (setCompany(res))
        });

        return {
            name: "",
            address: "",
            contact: "",
            gst: "",
            lastInvNo: 1,
            lastGstInvNo: 1,
        }
    })
    const [CashinHand, setCashinHand] = useState(0)
    const [stocksValue, setstocksValue] = useState(0)
    const [debit, setdebit] = useState(0)
    const [credit, setcredit] = useState(0)
    const [balance, setBalance] = useState(0)
    const [payable, setPayable] = useState(0)
    const [receivable, setReceivable] = useState(0)
    const [purchaseAmt, setPurchaseAmt] = useState(0)
    const [saleAmt, setSaleAmt] = useState(0);
    const [expenseAmt, setExpenseAmt] = useState(0);

    const getStocks = async () => {
        const res = await db.stocks.toArray();
        return res.map(item => {
            return updateStockItemData(item)
        })
    };

    const getStocksValue = async () => {
        const stocks = await getStocks();
        const stocksValue = stocks.reduce((acc, item) => {
            return acc + item.stockValue
        }, 0)
        return parseFloat(stocksValue);
    }

    const getInvoices = async () => {
        const res = await db.getInvoices();
        return res.map((inv) => {
            inv.billDate = new Date(inv.billDate)
            return inv
        })
    }

    const getSalesAmount = async () => {
        const invoices = await getInvoices();
        const saleAmt = invoices.reduce((acc, item) => {
            return acc + item.totalAmt
        }, 0)
        return parseFloat(saleAmt)
    }

    const getPurchase = async () => {
        const res = await db.purchase.reverse().toArray();
        return res.map((prc) => {
            prc.billDate = new Date(prc.billDate)
            return prc
        })
    }

    const getPurchaseAmount = async () => {
        const purchases = await getPurchase();
        const purchaseValue = purchases.reduce((acc, item) => {
            return acc + item.totalAmt
        }, 0)
        return parseFloat(purchaseValue)
    }

    const getLedger = async () => {
        const lgr = await db.getLedger();
        return lgr.map((item) => {
            item.date = new Date(item.date)
            return item
        })
    };

    const getLedgerValues = async () => {
        const ledger = await getLedger();
        let payable = ledger.length && ledger.reduce((sum, item) => {
            let totalsum = sum + item.payable;
            return parseFloat(totalsum);
        }, 0);
        let receivable = ledger.length && ledger.reduce((sum, item) => {
            let totalsum = sum + item.receivable;
            return parseFloat(totalsum);
        }, 0);
        let cashinHand = ledger.length && ledger.reduce((sum, item) => {
            let totalsum = sum + item.cash;
            return parseFloat(totalsum);
        }, 0);
        let { balance, credit, debit } = getBalanceCreditDebit(ledger);
        return {
            payable,
            receivable,
            cashinHand,
            balance,
            credit,
            debit
        }
    };

    const getExpenses = async () => {
        const res = await db.expenses.reverse().toArray();
        return res.map((exp) => {
            exp.expenseDate = new Date(exp.expenseDate)
            return exp
        })
    }

    const getExpenseAmount = async () => {
        const expenses = await getExpenses();
        const expenseValue = expenses.reduce((acc, item) => {
            return acc + item.amount
        }, 0)
        return parseFloat(expenseValue)
    }

    const getCustomerList = async () => {
        const res = await db.ledger.where({ isCustomer: 1 }).toArray();
        let list = [];
        res.forEach(element => {
            if (!list.includes(element.customerName)) {
                list.push(element.customerName)
            }
        });
        list.sort()
        return list;
    }

    const getPartyList = async () => {
        const res = await db.ledger.where({ isCustomer: 0 }).toArray();
        let list = [];
        res.forEach(element => {
            if (!list.includes(element.customerName)) {
                list.push(element.customerName)
            }
        });
        list.sort()
        return list;
    }

    const getCompany = async () => {
        const res = await db.companies.get(1);
        if (res) {
            return res
        }
        db.companies.put({
            name: "", address: "", contact: "", gst: "", lastInvNo: 1, lastGstInvNo: 1,
        });
        return {
            name: "", address: "", contact: "", gst: "", lastInvNo: 1, lastGstInvNo: 1,
        }
    }

    const getData = async () => {

        db.db.transaction('rw', db.stocks, db.invoices, db.purchase, db.ledger, db.companies, db.expenses, async () => {
            await db.stocks.toArray().then((res) => {
                res.map((stock) => {
                    return updateStockItemData(stock)
                })
                setStocks(res)

                let stocksVal = 0;
                if (res.length) {
                    stocksVal = res.reduce((sum, product) => {
                        let totalsum = sum + (product.stockValue);
                        return totalsum;
                    }, 0);
                    setstocksValue(stocksVal)
                }
            })

            await db.invoices.reverse().toArray().then((res) => {

                setInvoices(res.map((inv) => {
                    inv.billDate = new Date(inv.billDate)
                    return inv
                }));
                let sale = 0;
                if (res.length) {
                    sale = res.reduce((sum, item) => {
                        let totalsum = sum + item.totalAmt;
                        return totalsum;
                    }, 0);
                };
                setSaleAmt(sale)

            })

            await db.purchase.reverse().toArray().then((res) => {
                setPurchase(res.map((inv) => {
                    inv.billDate = new Date(inv.billDate)
                    return inv
                }));
                let purchase = 0;
                if (res.length) {
                    purchase = res.reduce((sum, item) => {
                        let totalsum = sum + item.totalAmt;
                        return totalsum;
                    }, 0);
                }
                setPurchaseAmt(purchase)
            })

            await db.ledger.toArray().then(res => {
                setLedger(res.map((inv) => {
                    inv.date = new Date(inv.date)
                    return inv
                }));

                let payable = 0;
                if (res.length) {
                    payable = res.reduce((sum, item) => {
                        let totalsum = sum + item.payable;
                        return totalsum;
                    }, 0);
                }

                let receivable = 0;
                if (res.length) {
                    receivable = res.reduce((sum, item) => {
                        let totalsum = sum + item.receivable;
                        return totalsum;
                    }, 0);
                }

                let cash = 0;
                if (res.length) {
                    cash = res.reduce((sum, item) => {
                        let totalsum = sum + item.cash;
                        return totalsum;
                    }, 0);
                }
                setCashinHand(parseFloat(cash))

                let { balance, credit, debit } = getBalanceCreditDebit(res);
                setBalance(balance);
                setdebit(debit);
                setcredit(credit);

                setPayable(parseFloat(payable));
                setReceivable(parseFloat(receivable));

            });

            await db.companies.get(1).then((res) => {
                res && (setCompany(res))
            }).catch((err) => console.log(err))

            await db.expenses.toArray().then((res) => {
                setExpenses(res);
                if (res.length > 0) {
                    let expAmt = jsonata("$sum($.amount)").evaluate(res);
                    setExpenseAmt(expAmt);
                }
            })
        }).then((o) => {
            console.log('Data Loaded', o);
        })
    }


    return (
        <ConfigContext.Provider
            value={{
                Config, setConfig,
                stocksValue, setstocksValue,
                setStocks, Stocks,
                Expenses, setExpenses,
                expenseAmt, setExpenseAmt,
                debit, setdebit,
                credit, setcredit,
                CashinHand, setCashinHand,
                balance, setBalance,
                payable, setPayable,
                receivable, setReceivable,
                purchaseAmt, setPurchaseAmt,
                saleAmt, setSaleAmt,
                Ledger, setLedger,
                Invoices, setInvoices,
                Purchase, setPurchase,
                CustomerList, setCustomerList,
                Company, setCompany,

                getData,
                getStocks, getStocksValue,
                getInvoices, getSalesAmount,
                getPurchase, getPurchaseAmount,
                getLedger, getLedgerValues,
                getExpenses, getExpenseAmount,
                getPartyList, getCustomerList,
                getCompany,


            }}
        >
            {props.children}
        </ConfigContext.Provider>
    );
};

export default ConfigContextProvider;
